import classes from './search.module.css';

interface SearchDialogProps {}

export const SearchDialog = (props: SearchDialogProps) => {
  return (
    <div className={classes.SearchDialog}>
      <div>Event filters to be shown here - TODO</div>
      <div>If used, only events will be shown on the results page</div>
    </div>
  );
};
